import React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './core/App';

const reactRoot = document.createElement('div');
reactRoot.id = 'react-root';
document.getElementsByTagName('body')[0].appendChild(reactRoot);

ReactDOM.render(
  <BrowserRouter>
    <App/>
  </BrowserRouter>,
  document.getElementById('react-root')
);
